module.exports = __webpack_public_path__ + "static/media/md-arrow-dropleft.4ffa51ae.svg";